import * as types from './mutation-types'

const mutations = {
  [types.SET_SEARCHOBJ] (state, searchObj) {
    state.searchObj = searchObj
  },
  [types.SET_NEWADDRESS] (state, obj) {
    state.newAddress = obj
  },
  [types.SET_INFOTOTAL] (state, obj) {
    state.infoTotal = obj
  },
  [types.SET_AREACODE] (state, arr) {
    state.areaCode = arr
  },
  [types.SET_USERINFO] (state, obj) {
    state.userInfo = obj
  },
  [types.SET_AVATAR] (state, img) {
    state.userInfo.headImage = img
  },
  [types.SET_CURRENTPRO] (state, obj) {
    state.currentPro = obj
  },
  [types.SET_SHOPPINGCART] (state, obj) {
    state.shoppingCart = obj
  },
  [types.SET_CARTNUMBER] (state, num) {
    state.cartNumber = num
  },
	addCartNum(state,num) {
		state.cartNumber += num
	},
	subCartNum(state,num) {
		state.cartNumber -= num
	},
	updateAddress(state,obj){
		state.newAddress.realName = obj.realName
		state.newAddress.phone = obj.phone
		state.newAddress.detail = obj.detail
		state.newAddress.isDefault = obj.isDefault
		state.areaCode = []
	},
	updateUserAvatar(state,avatar){
		state.userInfo.avatar = avatar
	}
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js